<template>
  <div class="uu-add-img">
    <!-- <el-form-item label="Take a selfie" prop="selfie" required> </el-form-item> -->

    <div class="imgactive" v-if="src !== ''">
      <img
        style="width: 100px; height: 100px; object-fit: contain"
        :src="src"
      />
      <span class="imgactiveafter" @click="removeimg">×</span>
    </div>
    <input
      v-if="src == ''"
      multiple
      type="file"
      accept="image/*"
      class="img-btn"
      ref="ipt"
      @change="updateImg"
    />
  </div>
</template>

<script>
import AWS from "aws-sdk";
import { Loading } from "element-ui";
import moment from "moment";

export default {
  name: "FileUpload",
  data() {
    return {
      selfiefileList: [],
      dialogImageUrl: "",
      dialogVisible: false,
      loadingInstance: {},
      disabled: false,
      awssrc: "",
      filevalue: "",
      src: "",
    };
  },
  props: { emitaction: String, fileurl: String },
  created() {
    let that = this;
    setTimeout(() => {
      if (that.fileurl) {
        that.src = that.fileurl;
      }
    }, 1000);
  },
  methods: {
    //获取路径
    imgUpLoad(allFile, indexCount) {
      // this.checkImgLogo = true;
      // if (indexCount >= allFile.length) {
      //     this.$refs.ipt.value = "";
      //     this.checkImgLogo = false;
      //     return;
      // }

      let file = allFile[0];

      let reader = new FileReader();
      let config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      // console.log(file,'file')
      reader.readAsDataURL(file); //用文件加载器加载文件
      reader.onload = (e) => {
        // let img = new Image();
        // img.src = e.target.result;
        this.src = e.target.result;
        // console.log(e.target.result,'e.target.result')
      };
      this.AWSupdateImg();
    },
    //上传头像
    updateImg(e) {
      // console.log(e.target.files)
      let indexCount = 0;

      let kb = e.target.files[0].size / 1024;
      // console.log(kb);
      if (kb > 512 * 10) {
        // this.$Toast("请上传小于100k的图片");

        this.$Message.error("请上传小于5mb的图片");
        return;
      }
      this.file = e.target.files[0];
      this.imgUpLoad(e.target.files, indexCount);
    },
    AWSupdateImg(e) {
      let that = this;
      this.loadingInstance = Loading.service({ fullscreen: true });
      // Indicator.open();
      let file = this.file;
      var nowtime = moment().valueOf();
      let filename = "userami/" + nowtime + this.randomString(20) + ".png";
      //  console.log(file)
      let s3 = new AWS.S3({
        accessKeyId: "AKIAREVQNU3CEQHLNE63",
        secretAccessKey: "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",
        Region: "ap-northeast-1",
        // sessionToken: nowtime,
      });
      let params = {
        Bucket: "utrsc" /* required */,
        Key: filename /* required */,
        Body: file,
        // "Access-Control-Allow-Credentials": "*",
        ACL: "public-read",
      };
      s3.upload(params, (err, data) => {
        // Indicator.close();
        if (err) {
          // this.$Toast("图片上传失败");
          this.$Message.error("upload error");
          this.loadingInstance.close();
          //  console.log(err, err.stack) // an error occurred
        } else {
          let src = s3.getSignedUrl("getObject", {
            Bucket: "utrsc",
            Key: filename,
          });
          // console.log(`getSignedUrl`)
          this.awssrc = src.split("?")[0];
          // this.$parent.setidfileurl(that.awssrc)
          that.$emit(`emitaction`, that.awssrc);
          this.file = null;
          this.loadingInstance.close();
        }
      });
    },
    handleRemove(file) {
      this.dialogImageUrl = "";
      this.dialogVisible = false;
      console.log(this.dialogVisible);
      console.log(file);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    fileChange(e) {
      this.filevalue = e.target.value;
    },
    removeimg() {
      this.src = "";
      this.fileurl == "";
    },
    selfieBeforeUpload(file) {
      let isRightSize = file.size / 1024 / 1024 < 2;
      if (!isRightSize) {
        this.$message.error("The file size is greater than 2MB");
      }
      return isRightSize;
    },
    randomString(len) {
      //默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1
      var chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
      var tempLen = chars.length,
        tempStr = "";
      for (var i = 0; i < len; ++i) {
        tempStr += chars.charAt(Math.floor(Math.random() * tempLen));
      }
      return tempStr;
    },
  },
};
</script>

<style>
.uu-add-img {
  position: relative;
  width: 100%;
  height: 100px;
}
.imgactive {
  position: absolute;
  width: 100px;
  height: 100px;
  left: 30%;
  margin-left: -50px;
  z-index: 1;
}
.imgactiveafter {
  position: absolute;
  right: -20px;
  top: -20px;
  padding-left: 2px;
  padding-right: 2px;
  font-size: 1.2rem;
  color: #ccc;
}
.uu-add-img input,.uu-add-img .imgactive {
  position: absolute;
  width: 100px;
  height: 100px;
  left: 38%;
  margin-left: -50px;
}
.uu-add-img .img-btn {
  border: none !important;
  overflow: hidden;
}

.uu-add-img .img-btn::after {
  content: "";
  padding: 0 !important;
  width: 100px;
  height: 100%;
  background: url("../../assets/images/addimg.png") #fff;
  position: absolute;
  left: 0;
  top: 0;
  background-size: cover;
}
</style>